<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment_report')"
    style="border: 1px solid #f5f5f5; width:100%;overflow: auto;display:block;background:whitesmoke;border-radius:4px;"
  >
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <div
      class="welcome"
      style="border: 0px solid red;display: inline-block;width:100%;"
    >
      <row style="border:0px solid green;display: inherit;width:100%;">
        <div
          style="text-align:center; font-size: 15px;text-align:left;color:#5b6c7f;width:100%;"
        >
          <div
            style="width:100%;border:0px solid blue;height:15px;text-align:center;"
          >
            <b style="font-weight:100; font-size:25px;color:navy;"
              >{{ $t("reportmonthly.report") }} - {{ getService }}
              {{ $t("reportmonthly.inputmonthly") }}
            </b>
          </div>
          <div style="border:1px solid #f4f4f4;margin-top:20px;height:45px;">
            <div class="row" style="margin-bottom:3px;">
              <div
                class="col-sm-6"
                style="display:-webkit-box;margin:5px 20px;float:right;border:0px solid red;text-align:right;display: flex; justify-content: flex-end"
              >
                <label
                  style="font-size: 15px;color: dodgerblue;font-weight: normal;margin-right:4px;margin-top:7px;"
                  >{{ $t("apartment.period") }}</label
                >
                <date-picker
                  @dp-change="changeDateTime($event)"
                  class="form-control"
                  v-model="period_picker"
                  :config="options"
                  style="width: 25%;"
                ></date-picker>
                <lte-button
                  type="btn
                            btn-primary"
                  right_icon="fa
                            fa-plus"
                  @click="onExport($event)"
                  v-if="has_perm('export_apartment_report')"
                  style="margin-left:4px;"
                  >{{ $t("apartment.expotExcel") }}</lte-button
                >
              </div>
              <div style="clear:both"></div>
            </div>
          </div>
        </div>
        <div style="clear:both"></div>
        <div style="text-align:left;border:0px solid red;color:red;">
          <div
            style="margin-left:10px;margin-top:3px;border-radius:4px;background-color:lightblue;width:50px;height:15px;float:left;"
          ></div>
          &nbsp;{{ $t("apartment.apartments_not_yet_hand_over") }}
        </div>
        <lte-table
          :hdBackground="hdBackground"
          :data="reportMonthlyUsage"
          :columns="item.serviceid < 3 ? gridColumns : gridColumnsOrtherService"
          :useFilter="false"
          :useFilterSelect="true"
          :customColumns="customColumns"
          :paymentStatusOptions="paymentStatus"
          search_filter="left-search"
          @filters="filterData"
          :arrow="arrow"
          :status_field="status_field"
          style="border:1px solid #dbdbdb;margin-top:5px;"
        ></lte-table>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import XLSX from "xlsx";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";

export default {
  name: "ReportMonthly",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      reportMonthlyUsage: [],
      excelData: [],
      gridColumns: [
        "common.nonumber",
        "apartment.apartment_code",
        "service_history.last_month_value",
        "service_history.this_month_value",
        "service_history.status",
        "apartment.rental_status",
        "service_history.total_fees"
      ],
      gridColumnsOrtherService: [
        "common.nonumber",
        "apartment.apartment_code",
        "service_history.status",
        "apartment.rental_status",
        "service_history.total_fees"
      ],
      customColumns: {
        "service_history.total_fees": "label-success",
        "service_history.status": {
          "apartment.open": "label-warning",
          "apartment.issue": "label-primary",
          "apartment.paid": "label-success"
        }
      },
      useFilter: true,
      hdBackground:
        "background-color:whitesmoke !important;is-hoverable is-striped;color:#363636;border:1px solid #dbdbdb;border-width: 1px 1px 2px 1px;", //00a65a
      tblBorder: "border: 1px solid orange",
      arrow: "other_color_arrow",
      originalRecordData: [],
      isModalVisible: false,
      status_field: {
        "apartment.apartment_status": 1
      },
      paginatorItem: {
        commit_function: "GET_APARTMENT_LIST"
      },
      serviceid: 1,
      msgNotFound: false,
      isLoading: false,
      summaryTotal: 0,
      unpaidTotal: 0,
      paidTotal: 0,
      paymentStatus: [],
      period_picker: null,
      options: {
        format: "MM/YYYY",
        useCurrent: true,
        locale: "vi"
      }
    };
  },
  watch: {
    GET_INVOICE_STATUS_DATA: function() {
      let data = this.GET_INVOICE_STATUS_DATA;
      let description = "";
      this.paymentStatus = [];
      for (let i = 0, size = data.length; i < size; i++) {
        if (data[i].status_code == "O") {
          description = this.$t("apartment.open");
        } else if (data[i].status_code == "I") {
          description = this.$t("apartment.issue");
        } else if (data[i].status_code == "P") {
          description = this.$t("apartment.paid");
        }
        if (data[i].status_code !== "C" && data[i].status_code !== "PP") {
          this.paymentStatus.push({ text: description, id: data[i].id });
        }
      }
    },
    GET_REPORT_MONTHLY_USAGE_DATA: function() {
      this.reportMonthlyUsage = [];
      this.summaryTotal = 0;
      this.paidTotal = 0;
      this.unpaidTotal = 0;
      this.GET_REPORT_MONTHLY_USAGE_DATA.forEach((reportmonthlyusage, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let id = reportmonthlyusage.id;
        let apartment_code = reportmonthlyusage.apartment_code;
        let last_month_value = reportmonthlyusage.last_month_value;
        let this_month_value = reportmonthlyusage.this_month_value;
        let total_fees = utils.makeRoundNumber(reportmonthlyusage.total_fees);
        let status = reportmonthlyusage.status;
        let apartment_status = reportmonthlyusage.apartment_status;
        let rental_status = reportmonthlyusage.apartment_status;
        this.summaryTotal += total_fees;

        if (status == 1) {
          status = this.$t("apartment.open");
          this.unpaidTotal += total_fees;
        } else if (status == 2) {
          status = this.$t("apartment.issue");
          this.unpaidTotal += total_fees;
        } else if (status == 3) {
          status = this.$t("apartment.paid");
          this.paidTotal += total_fees;
        } else if (status == 4) {
          status = this.$t("report.cancelled");
        } else {
          status = "Partial paid";
          this.paidTotal += total_fees;
        }
        // Apartment Status: Ban Giao, Chua Ban Giao, Da o
        if (rental_status == 1) {
          rental_status = this.$t("apartment_status.not_handover");
        } else if (rental_status == 2) {
          rental_status = this.$t("apartment_status.handover");
        } else if (rental_status == 3) {
          rental_status = this.$t("apartment_status.occupied");
        } else {
          rental_status = "Unknow";
        }
        let data = {
          id: id,
          "common.nonumber": nonumber,
          "apartment.apartment_code": apartment_code,
          "service_history.last_month_value": last_month_value,
          "service_history.this_month_value": this_month_value,
          "service_history.status": status,
          "apartment.rental_status": rental_status,
          "apartment.apartment_status": apartment_status,
          "service_history.total_fees": utils.formatNumber(total_fees)
        };
        this.reportMonthlyUsage.push(data);
      });
      if (this.reportMonthlyUsage.length <= 0) {
        this.msgNotFound = true;
      } else {
        this.msgNotFound = false;
      }
      this.isLoading = false;
      this.$emit(
        "summary_total",
        this.summaryTotal,
        this.paidTotal,
        this.unpaidTotal
      );
      this.GET_INVOICE_STATUS_LIST();
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_REPORT_MONTHLY_USAGE_DATA",
      "GET_INVOICE_STATUS_DATA",
      "GET_ACCOUNT_DATA"
    ]),
    getService: function() {
      this.waitingLoading(true);
      let service_name = "";
      let service = this.item.serviceid;
      if (service == 1) {
        service_name = this.$t("reportmonthly.electric");
      } else if (service == 2) {
        service_name = this.$t("reportmonthly.water");
      } else if (service == 3) {
        service_name = this.$t("reportmonthly.parking");
      } else if (service == 7) {
        service_name = this.$t("reportmonthly.management_fee");
      } else {
        service_name = "Unknow";
      }
      if (this.item.activated) {
        // let currentDate = new Date();
        // let getCurrentYear = currentDate.getFullYear();
        const payload = {
          params: {
            month: utils.formatSqlDate(this.period_picker, "MM/YYYY", "MM"),
            year: utils.formatSqlDate(this.period_picker, "MM/YYYY", "YYYY"),
            serviceid: service
          }
        };
        this.getReportMonthlyUsage(payload);
        this.setActivated(false);
      } else {
        this.waitingLoading(false);
      }
      return service_name;
    }
  },
  created() {
    this.period_picker = moment().subtract(1, "months").format("MM/YYYY");
  },
  methods: {
    changeDateTime: function(event) {
      event.preventDefault();
      this.isLoading = true;
      this.setActivated(true);
      let month = utils.formatSqlDate(this.period_picker, "MM/YYYY", "MM");
      let year = utils.formatSqlDate(this.period_picker, "MM/YYYY", "YYYY");
      const data = {
        params: {
          month: month,
          year: year,
          serviceid: this.item.serviceid
        }
      };
      this.GET_REPORT_MONTHLY_USAGE_LIST(data);
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getReportMonthlyUsage: function(payload) {
      this.GET_REPORT_MONTHLY_USAGE_LIST(payload)
        .then(
          function() {
            if (this.serviceMonthlyUsageInputsFilter >= 0) {
              this.waitingLoading(false);
            }
          }.bind(this)
        )
        .catch(
          function() {
            this.waitingLoading(false);
          }.bind(this)
        );
    },
    setActivated: function(bol) {
      this.item.activated = bol;
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentAdd",
        params: {
          id: 0
        }
      });
    },
    filterData: function(emitfilteredData) {
      this.excelData = emitfilteredData;
    },
    onExport: async function() {
      this.json_data_export = [];
      let summaryTotal = 0;
      await this.excelData.forEach(v => {
        if (
          v["apartment.rental_status"] ==
            this.$t("apartment_status.handover") ||
          v["apartment.rental_status"] == this.$t("apartment_status.occupied")
        ) {
          let json_data = {
            "Mã Căn": v["apartment.apartment_code"],
            "Chỉ Số Củ": v["service_history.last_month_value"],
            "Chỉ Số Mới": v["service_history.this_month_value"],
            "Tình Trạng": v["service_history.status"],
            "Trạng Thái": v["apartment.rental_status"],
            "Tổng Phí": parseInt(
              v["service_history.total_fees"].replace(/,/g, "")
            )
          };
          summaryTotal += parseInt(
            v["service_history.total_fees"].replace(/,/g, "")
          );
          this.json_data_export.push(json_data);
        }
      });
      this.summaryTotal = summaryTotal;
      let json_summary_total = {
        "Mã Căn": "",
        "Chỉ Số Củ": "",
        "Chỉ Số Mới": "",
        "Tình Trạng": "Total",
        "Trạng Thái": "",
        "Tổng Phí": this.summaryTotal
      };

      this.json_data_export.push(json_summary_total);

      let service_name = "";
      if (this.item.serviceid == 1) {
        service_name = this.$t("reportmonthly.electric");
      } else if (this.item.serviceid == 2) {
        service_name = this.$t("reportmonthly.water");
      } else if (this.item.serviceid == 3) {
        service_name = this.$t("reportmonthly.parking");
      } else {
        service_name = this.$t("reportmonthly.managementfee");
      }
      // export json to Worksheet of Excel
      // only array possible
      var reports = XLSX.utils.json_to_sheet(this.json_data_export);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, reports, service_name); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "ReportMonthly.xlsx"); // name of the file is 'book.xlsx'
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_REPORT_MONTHLY_USAGE_LIST",
      "GET_INVOICE_STATUS_LIST"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    loading: Loading,
    "date-picker": datePicker
  },
  mounted() {
    this.isLoading = false;
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Apartment/ReportMonthly.vue